import DamageTypePage from "@/components/damageType/DamageTypePage";

const Datenverlust = () => <DamageTypePage slug="datenverlust" />;
export default Datenverlust;
